// libs
import React from 'react';
import PropTypes from 'prop-types';
// shared components
import { RefreshIcon, DownloadIcon } from 'components/library';
// scss
import './download-link.scss';

class DownloadLink extends React.Component {

    handleClick = event => {
        event.preventDefault();

        if ( !this.props.busy ) {
            this.props.onClick();
        }
    }

    render() {
        const { busy, children } = this.props;
        return (
            <a href="#" className="download-link" onClick={ this.handleClick }>
                <span className={ busy ? 'icon busy' : 'icon' } >
                    { busy ? <RefreshIcon/> : <DownloadIcon/> }
                </span>
                { children }
            </a>
        );
    }

}

DownloadLink.propTypes = {
    children: PropTypes.node,
    onClick: PropTypes.func.isRequired,
    busy: PropTypes.bool
};

export default DownloadLink;
